import { effect, inject, Injectable, signal, untracked } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';
import { SupportApiService } from './support-api.service';

const POLL_INTERVAL_MS = 60_000;

/** Unread support-reply count for the signed-in user, polled while the tab is visible. */
@Injectable({ providedIn: 'root' })
export class SupportUnreadService {
  private readonly api = inject(SupportApiService);
  private readonly auth = inject(AuthService);
  private wasSignedIn = false;
  private timer: ReturnType<typeof setInterval> | null = null;

  private readonly countSignal = signal(0);
  readonly count = this.countSignal.asReadonly();

  constructor() {
    effect(() => {
      const user = this.auth.currentUser();
      untracked(() => {
        if (user) {
          this.wasSignedIn = true;
          this.start();
        } else if (this.wasSignedIn) {
          this.wasSignedIn = false;
          this.stop();
          this.countSignal.set(0);
        }
      });
    });
  }

  start(): void {
    this.stop();
    this.refresh();
    this.timer = setInterval(() => {
      if (document.visibilityState === 'visible') this.refresh();
    }, POLL_INTERVAL_MS);
  }

  refresh(): void {
    this.api.unreadCount().subscribe({
      next: (n) => this.countSignal.set(n),
      error: () => undefined, // a failed poll keeps the last known count
    });
  }

  stop(): void {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
